import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import styles from '@patternfly/react-styles/css/components/Panel/panel.mjs';
import { css } from '@patternfly/react-styles';
export const PanelFooter = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (_jsx("div", Object.assign({ className: css(styles.panelFooter, className) }, props, { children: children })));
};
PanelFooter.displayName = 'PanelFooter';
//# sourceMappingURL=PanelFooter.js.map